import React from "react";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import { TID } from "@/lib/testIds";

const FAQS = [
  { q: "What type of data is available?", a: "Firmographic and contact-level B2B data. Business emails, titles, seniority, department, company size, industry, technographics (where available), and LinkedIn URLs where available." },
  { q: "Is a subscription required?", a: "No. ExactReach is pay-per-project. No annual commitment. No expiring monthly credits." },
  { q: "When will the estimate arrive?", a: "Typically within one business day. Complex requests may take longer — we'll tell you if that's the case." },
  { q: "How many sample records are provided?", a: "Up to 20 sample records with your quote. The final volume and fields are governed by the approved quotation." },
  { q: "When is payment required?", a: "Only after you review the estimate, sample and quotation, and approve an option." },
  { q: "What does Verified Data mean?", a: "Business emails are freshly re-verified close to fulfilment. Invalid emails are removed or replaced according to the order terms." },
  { q: "Can I upload suppression lists?", a: "Yes. CSV or XLSX files with accounts or contacts to exclude." },
  { q: "Can I request specific companies?", a: "Yes — upload a target account list (CSV/XLSX) or list them in the request form." },
  { q: "Can international customers purchase?", a: "Yes. Quotes can be issued in USD, EUR, GBP (configurable)." },
  { q: "How is my information protected?", a: "Files are stored in private object storage with signed, time-limited download links. Session tokens are HttpOnly. Delivery files are never accessible before payment and QA approval." },
  { q: "Can a previous audience be reordered?", a: "Yes. From your dashboard, duplicate any previous request to reuse its criteria." },
];

export default function FAQ() {
  return (
    <div className="App min-h-screen">
      <Navbar />
      <section className="section border-b border-border">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <div className="text-xs tracking-widest-2 uppercase text-muted-foreground font-semibold mb-3">Support</div>
          <h1 className="font-heading font-black tracking-tighter text-5xl md:text-6xl">Frequently asked questions.</h1>
        </div>
      </section>
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          {FAQS.map((f, i) => (
            <details key={f.q} data-testid={`${TID.home.faqItem}-${i}`} className="group border-b border-border py-5">
              <summary className="flex items-center justify-between cursor-pointer list-none">
                <span className="font-semibold text-base pr-4">{f.q}</span>
                <span className="text-2xl leading-none text-muted-foreground group-open:rotate-45 transition-transform">+</span>
              </summary>
              <p className="text-sm text-muted-foreground mt-3 leading-relaxed">{f.a}</p>
            </details>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
}
